export default {
  source: {
    url: "mapbox://mepa1363.9raq18ol"
  },
  layer: {
    id: "accessibility-bikeways",
    source: "pickyourplace_bikeways",
    minZoom: 5,
    maxZoom: 22,
    color: "#ffffcc"
  }
};
